import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import $ from "jquery";
import { EventBus } from "../../Controls/EventBus";
import { BulletinHeaderDto } from "../../../dto/GenApi.iNotPaie.Dto/BulletinHeaderDto";
import ModalEditionBulletins from "../../calculDePaie/modalEditionBulletins/modalEditionBulletins";
import { ModalAlerteOptions } from "../../modalComponents/modalAlerte/modalAlerte";
import EventConstants from "../../Controls/EventConstants";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

interface modelBulletinSalarie {
	route: string;
	errorMessage: string[];
	BulletinHeader: BulletinHeaderDto[];
	currentBulletin?: BulletinHeaderDto;
	isModified: boolean;
}

@Component({
	components: {
		ModalEditionBulletins: require("../../calculDePaie/modalEditionBulletins/modalEditionBulletins.vue.html")
	}
})
export default class ReglementSalarieComponent extends Vue {
	public currentId = 0;
	public dataReady = false;
	public isModified = false;
	public BulletinHeader: BulletinHeaderDto[] = [];
	public salarieCharges: modelBulletinSalarie[] = [];
	public errorMessage: string[] = [];
	public currentBulletin?: BulletinHeaderDto = undefined;
	public isLoadingBulletin = false;

	public currentData?: Blob = undefined;
	public currentDataUrl?: string = undefined;

	public reloadData(id: number): void {
		if (this.currentId > 0) {
			this.salarieCharges[this.currentId] = {
				isModified: this.isModified,
				BulletinHeader: this.BulletinHeader,
				currentBulletin: this.currentBulletin,
				errorMessage: this.errorMessage,
				route: this.$router.currentRoute.path
			};
		}
		this.currentId = id;
		this.fetchData();
	}

	public updateCurrentData(): void {
		this.isLoadingBulletin = true;

		if (this.currentBulletin == undefined) {
			this.currentData = undefined;
			this.currentDataUrl = "";
			this.isLoadingBulletin = false;

			this.$forceUpdate();

			return;
		}

		const idDejaCharge = this.currentBulletin.IdContrat * 1000000 + this.currentBulletin.Annee * 100 + this.currentBulletin.Mois;

		ServicesFactoryInstance.CalculPaieService.GetBulletin(this.currentBulletin.IdContrat, this.currentBulletin.Annee, this.currentBulletin.Mois, data => {

			if (this.currentBulletin == undefined) {
				this.currentData = undefined;
				this.currentDataUrl = "";
				this.isLoadingBulletin = false;

				return;
			}

			const idCurrent = this.currentBulletin.IdContrat * 1000000 + this.currentBulletin.Annee * 100 + this.currentBulletin.Mois;
			if (idCurrent == idDejaCharge) {
				this.currentData = data;
				this.currentDataUrl = URL.createObjectURL(this.currentData);
				this.isLoadingBulletin = false;

				this.$forceUpdate();
			}
		});
		
	}

	public sendPdf(): void {
		if (this.currentBulletin == undefined) {
			return;
		}

		const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
			message: "Souhaitez-vous vraiment envoyer les bulletins par mail ?",
			callBackYes: () => {
				if (this.currentBulletin == undefined) {
					return;
				}
				NotificationServiceInstance.SendSuccess("Envoi du bulletin de paie.");
				ServicesFactoryInstance.CalculPaieService.SendBulletin(this.currentBulletin.IdContrat, this.currentBulletin.Annee, this.currentBulletin.Mois, () =>
					NotificationServiceInstance.SendSuccess("Le bulletin de paie a été envoyé."));
			}
		});

		EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	public downloadPdf(bulletin: BulletinHeaderDto): void {
		this.currentData = undefined;
		this.currentDataUrl = "";

		ServicesFactoryInstance.CalculPaieService.GetBulletin(bulletin.IdContrat, bulletin.Annee, bulletin.Mois, data => {
			this.download(data);
			this.$forceUpdate();
		});
		
	}

	public download(r: Blob): void {
		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(r, "bulletins de salaire.pdf");
			this.dataReady = true;
		} else {
			this.dataReady = true;

			const link = document.createElement("a");
			document.body.appendChild(link);

			link.href = window.URL.createObjectURL(r);
			link.download = "bulletins de salaire.pdf";
			link.click();
		}
	}

	public resetData(id: number): void {
		if (this.salarieCharges[id] != undefined) {
			this.salarieCharges[id].isModified = false;
		}
		if (this.currentId == id) {
			this.fetchData();
		}
	}

	public fetchData(): void {
		if (this.currentId < 1) {
			return;
		}
		this.dataReady = false;
		if (this.salarieCharges[this.currentId] == null || !this.salarieCharges[this.currentId].isModified) {
			ServicesFactoryInstance.CalculPaieService.GetBulletins(this.currentId, data => {
				this.BulletinHeader = data;
				if (this.BulletinHeader.length > 0) {
					this.currentBulletin = this.BulletinHeader[0];
				} else {
					this.currentBulletin = undefined;
				}
				this.dataReady = true;
				this.updateCurrentData();
			});
		} else {
			this.errorMessage = this.salarieCharges[this.currentId].errorMessage;
			this.BulletinHeader = this.salarieCharges[this.currentId].BulletinHeader;
			this.currentBulletin = this.salarieCharges[this.currentId].currentBulletin;
			this.isModified = this.salarieCharges[this.currentId].isModified;
			this.dataReady = true;
			this.updateCurrentData();
		}
	}

	public selectBulletin(bulletin: BulletinHeaderDto): void {
		this.currentBulletin = bulletin;
		this.$forceUpdate();
		this.updateCurrentData();
	}

	public modalEditionBulletins?: ModalEditionBulletins = undefined;

	public imprimer(): void {
		if (this.BulletinHeader.length == 0)
			{return;}

		let listeIdContrats: number[] = [];
		ServicesFactoryInstance.SalarieService.getSalarieContratHistorique(this.currentId, contratsHistorique => {
			contratsHistorique.forEach(contrat => {
				if (contrat.IdContrat == undefined)
					return;
				listeIdContrats.push(contrat.IdContrat);
			});

			this.modalEditionBulletins = this.$refs.modalEditionBulletins as ModalEditionBulletins;

			this.modalEditionBulletins.Init([{
				IdContrat: listeIdContrats,
				selected: true
			}]);
			$("#modalEditionBulletins").modal("show");
		});
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSalarie/bulletins/bulletins.ts